export default __webpack_public_path__ + "static/media/new-upload-selected.f26431cd.svg";